export const isIncubatorPage = (): boolean => {
    const {pathname} = window.location;

    return Boolean(pathname.includes('/play/incubator') ||
        pathname.includes('/play/sport_incubator'));
};
